import { render } from "./Round1.vue?vue&type=template&id=575875fe"
import script from "./Round1.vue?vue&type=script&lang=js"
export * from "./Round1.vue?vue&type=script&lang=js"

import "./Round1.vue?vue&type=style&index=0&id=575875fe&lang=css"
script.render = render

export default script